import { StoreProvider } from '@starberry/components';

import { AuthContext, AuthInitialState } from 'core/services/store/auth/store';
import AuthStoreReducer from 'core/services/store/auth/reducer';

import { UserObjectContext, UserObjectInitialState } from 'core/services/store/userobject/store';
import UserObjectReducer from 'core/services/store/userobject/reducer';

import { ActionContext, ActionInitialState } from 'core/services/store/action/store';
import ActionReducer from 'core/services/store/action/reducer';

import { MyAccountContext, MyAccountInitialState } from 'core/services/store/myaccount/store';
import MyAccountReducer from 'core/services/store/myaccount/reducer';

import { ActivityContext, ActivityInitialState } from 'core/services/store/activity/store';
import ActivityReducer from 'core/services/store/activity/reducer';

import { FormContext, FormInitialState } from 'core/services/store/form/store';
import FormReducer from 'core/services/store/form/reducer';

import { ProfileContext, ProfileInitialState } from 'core/services/store/profile/store';
import ProfileReducer from 'core/services/store/profile/reducer';

import ActionServices from 'core/services/store/action/services';
import * as ActionActions from 'core/services/store/action/actions';

import UserObjectServices from 'core/services/store/userobject/services';
import * as UserObjectActions from 'core/services/store/userobject/actions';

import MyAccountServices from 'core/services/store/myaccount/services';
import * as MyAccountActions from 'core/services/store/myaccount/actions';

import ActivityServices from 'core/services/store/activity/services';
import * as ActivityActions from 'core/services/store/activity/actions';

// import ProfileServices from './services/store/profile/services';
// import * as ProfileActions from './services/store/profile/actions';

const serviceGetter = (services, actions, getter) => {
  return (state, dispatch) => {
    getter(services(dispatch, actions), state, dispatch);
  };
};

export default {
  auth: StoreProvider(AuthInitialState, AuthStoreReducer, AuthContext),
  userprofile: StoreProvider(ProfileInitialState, ProfileReducer, ProfileContext),
  userobject: StoreProvider(UserObjectInitialState, UserObjectReducer, UserObjectContext, {
    properties: serviceGetter(UserObjectServices, UserObjectActions, (userService, state) => {
      if (!state.loading.properties) {
        userService.getProperties();
      }
    }),
    savedProperties: serviceGetter(UserObjectServices, UserObjectActions, (userService, state) => {
      if (!state.loading.savedProperties) {
        userService.getSavedProperties();
      }
    }),
    savedSearches: serviceGetter(UserObjectServices, UserObjectActions, (userService, state) => {
      if (!state.loading.savedSearches) {
        userService.getSavedSearches();
      }
    }),
  }),
  action: StoreProvider(ActionInitialState, ActionReducer, ActionContext, {
    pendingActionData: serviceGetter(ActionServices, ActionActions, (actionService, state) => {
      if (!state.loading) {
        actionService.getPendingActions();
      }
    }),
  }),
  myaccount: StoreProvider(MyAccountInitialState, MyAccountReducer, MyAccountContext, {
    allProperties: serviceGetter(MyAccountServices, MyAccountActions, (myAccountService, state) => {
      if (!state.loading) {
        myAccountService.getAllProperties();
      }
    }),
    latestProperties: serviceGetter(
      MyAccountServices,
      MyAccountActions,
      (myAccountService, state) => {
        if (!state.loading) {
          myAccountService.getLatestProperties({
            _limit: 12,
          });
        }
      }
    ),
  }),
  activity: StoreProvider(ActivityInitialState, ActivityReducer, ActivityContext, {
    activities: serviceGetter(ActivityServices, ActivityActions, (activityService, state) => {
      if (!state.loading) {
        activityService.getActivities();
      }
    }),
  }),
  form: StoreProvider(FormInitialState, FormReducer, FormContext),
};
